module.exports = __webpack_public_path__ + "img/pay_unionpay.672ff9b0.png";